import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Icons from "lucide-react";
import { pickLocale } from "@/lib/helpers";
import { track } from "@/api/analytics";

/** Tile in the Info Utili grid. Every tile is a navigable link. */
export default function InfoTile({ category }) {
  const { i18n } = useTranslation();
  const Icon = Icons[category.icon] || Icons.MapPin;
  const label = pickLocale(category.name, i18n.language) || "";
  // Auto-fit label size: longer strings step down to keep tiles balanced.
  const labelSize =
    label.length > 18 ? "text-[8.5px]" : label.length > 13 ? "text-[9.5px]" : "text-[10px]";

  const isMeteo = category.slug === "meteo";

  return (
    <Link
      to={`/categoria/${category.slug}`}
      onClick={() =>
        track(isMeteo ? "view_weather" : "view_category", {
          target_type: "category",
          target_id: category.id,
        })
      }
      data-testid={`info-tile-${category.slug}`}
      className="group flex flex-col items-center justify-center gap-2.5 aspect-square rounded-2xl bg-white border border-ink-200/40 shadow-soft transition-all hover:-translate-y-0.5 hover:shadow-elevated hover:border-bronze-200 active:scale-95 p-3 w-full"
    >
      <div className="w-11 h-11 rounded-xl bg-ivory-100 flex items-center justify-center transition-colors group-hover:bg-bronze-50">
        <Icon strokeWidth={1.3} className="w-[19px] h-[19px] text-bronze-400" />
      </div>
      <div
        className={`text-center ${labelSize} font-semibold tracking-overline text-ink-700 leading-tight px-1`}
      >
        {label}
      </div>
    </Link>
  );
}
